import {
  createRatingScreenModel,
  type RatingScreenProps,
} from './RatingScreenModelScreen';
import { RatingScreenController } from './RatingScreenController';
import { RatingScreenView } from './RatingScreenView';
import { useInfoPopupState } from '../shared/infoPopup/infoPopupState';

export type { RatingScreenProps } from './RatingScreenModelScreen';

export function RatingScreen(props: RatingScreenProps) {
  const infoPopup = useInfoPopupState();
  const model = createRatingScreenModel(props, infoPopup);
  const controller = new RatingScreenController(model);

  return <RatingScreenView model={model} controller={controller} />;
}
